import 'classlist-polyfill'; // [< EDGE] Adding full support for 'Element.classList'
import 'core-js/es6/array'; // [<= IE11]
import 'core-js/es6/math'; // [<= IE11]
import 'custom-event-polyfill'; // [<= IE11] Polyfill CustomEvent constructor
require('mutation-observer'); // [<= IE10] Polfill adding support for MutationObserver used for our directives.
require('./custom-polyfills/event-constructor'); // [<= IE11] Polyfill Event constructor